import { useEffect, useState } from 'react';

const DEMO_PASSWORD = 'valamar2026';
const STORAGE_KEY = 'valamar_demo_auth';

async function sha256(text) {
  const data = new TextEncoder().encode(text);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

let cachedHash = null;

async function getPasswordHash() {
  if (!cachedHash) {
    cachedHash = await sha256(DEMO_PASSWORD);
  }
  return cachedHash;
}

export default function PasswordGate({ onUnlock }) {
  const [input, setInput] = useState('');
  const [error, setError] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    async function checkStored() {
      const hash = await getPasswordHash();
      if (localStorage.getItem(STORAGE_KEY) === hash) {
        onUnlock();
      }
      setChecking(false);
    }
    checkStored();
  }, [onUnlock]);

  async function handleSubmit(e) {
    e.preventDefault();
    const hash = await getPasswordHash();
    const inputHash = await sha256(input.toLowerCase().trim());
    if (inputHash === hash) {
      localStorage.setItem(STORAGE_KEY, hash);
      setError(false);
      onUnlock();
    } else {
      setError(true);
    }
  }

  if (checking) {
    return (
      <div className="demo-gate">
        <div className="demo-gate-card">Loading…</div>
      </div>
    );
  }

  return (
    <div className="demo-gate">
      <div className="demo-gate-card">
        <div className="demo-gate-logo">Valamar</div>
        <div className="demo-gate-claim">Holiday as you are</div>
        <h1 className="demo-gate-title">AI Concierge Demo</h1>
        <p className="demo-gate-sub">
          Confidential demonstration built by SeaCloud Software.
          Enter access code to continue.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            className="demo-gate-input"
            placeholder="Access code"
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setError(false);
            }}
            autoFocus
          />
          <button type="submit" className="demo-gate-btn">
            Enter Demo
          </button>
        </form>
        {error && <p className="demo-gate-error">Incorrect access code</p>}
        <p className="demo-gate-foot">Demo only — not connected to live Valamar systems</p>
      </div>
    </div>
  );
}
